// extracted by mini-css-extract-plugin
module.exports = {"custom-link-meta":"_3g6xMOuSmv71rqtcWhnfcu","submenu-item":"_1ncSUF9BmK7vdpjiICqocF"};